import Header from './shared/Header';
import Footer from './shared/Footer';
import Copyright from './shared/Copyright';
import Home from './layout/Home'
import About from './layout/About'
import Contact from './layout/Contact'
import Services from './layout/Services'
import PageNotFound from './components/PageNotFound'
import { Route, Switch, useLocation } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import ScrollProgress from './components/ScrollProgress'
import WorkplaceSafety from './layout/WorkplaceSafety';
import useScrollReveal from './hooks/useScrollReveal';
import useSpotlight from './hooks/useSpotlight';

function App() {
  const location = useLocation()
  useScrollReveal(location.pathname)
  useSpotlight()

  return (
    <>
      <ScrollProgress />
      <Header />
      <ScrollToTop />
      {/* Keyed on the path so each route plays its entrance transition */}
      <main className="page-enter" key={location.pathname}>
        <Switch location={location}>
          <Route exact path='/' component={Home} />
          <Route exact path='/about' component={About} />
          <Route exact path='/services' component={Services} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path="/workplace_safety" component={WorkplaceSafety}/>
          <Route path='*' exact={true} component={PageNotFound} />
        </Switch>
      </main>
      <Footer />
      <Copyright />
    </>
  );
}

export default App;
